
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 20.36","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"brazil-flag-svgrepo-com","transform":"translate(0 -102.72)"}},[_c('g',{attrs:{"id":"Group_2","data-name":"Group 2","transform":"translate(0 102.72)"}},[_c('g',{attrs:{"id":"Group_1","data-name":"Group 1"}},[_c('path',{attrs:{"id":"Path_1","d":"M32.66 102.72H1.34A1.34 1.34 0 000 104.06v17.68a1.34 1.34 0 001.34 1.34h31.32a1.34 1.34 0 001.34-1.34v-17.68a1.34 1.34 0 00-1.34-1.34zm-1.34 17.67H2.68v-14.98h28.64v14.98z","data-name":"Path 1","transform":"translate(0 -102.72)"}})])]),_c('g',{attrs:{"id":"Group_4","data-name":"Group 4","transform":"translate(7.18 105.61)"}},[_c('g',{attrs:{"id":"Group_3","data-name":"Group 3"}},[_c('path',{attrs:{"id":"Path_2","d":"M120.61 154.32l-8.53-5.92a1.22 1.22 0 00-1.4 0l-8.53 5.92a1.42 1.42 0 000 2.29l8.53 5.92a1.22 1.22 0 001.4 0l8.53-5.92a1.42 1.42 0 000-2.3zm-9.23 5.43l-6.18-4.29 6.18-4.29 6.18 4.3z","data-name":"Path 2","transform":"translate(-101.56 -148.17)"}})])]),_c('g',{attrs:{"id":"Group_6","data-name":"Group 6","transform":"translate(15.14 111.05)"}},[_c('g',{attrs:{"id":"Group_5","data-name":"Group 5"}},[_c('circle',{attrs:{"id":"Ellipse_1","cx":"1.85","cy":"1.85","r":"1.85","data-name":"Ellipse 1"}})])])])])
          )
        }
      }
    